import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sun, Moon, Mic } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Contact', path: '/contact' },
];

const SiteHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const { user } = useAuth();

  return (
    <nav className="fixed top-0 w-full z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center group-hover:scale-105 transition-transform">
            <Mic className="w-4 h-4 text-white" />
          </div>
          <span className="font-bold text-lg font-outfit text-foreground">VoiceraLab</span>
        </button>

        <div className="hidden md:flex items-center gap-6 text-sm">
          {NAV_LINKS.map(link => (
            <button
              key={link.path}
              onClick={() => navigate(link.path)}
              className={`transition-colors ${location.pathname === link.path ? 'text-primary font-medium' : 'text-muted-foreground hover:text-foreground'}`}
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button onClick={toggleTheme} className="p-2 rounded-lg bg-secondary hover:bg-secondary/70 transition-colors">
            {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
          {user ? (
            <button onClick={() => navigate('/dashboard')} className="gradient-btn px-5 py-2.5 rounded-full text-sm font-medium">Dashboard</button>
          ) : (
            <>
              <button onClick={() => navigate('/auth?mode=login')} className="px-4 py-2.5 rounded-full text-sm font-medium text-foreground hover:bg-secondary transition-colors hidden sm:block">Sign in</button>
              <button onClick={() => navigate('/auth?mode=register')} className="gradient-btn px-5 py-2.5 rounded-full text-sm font-medium">Get Started</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default SiteHeader;
